// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/paintbrush.js';

import { paths } from '../generated/paintbrush';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('paintbrush', Original, paths);
